import React, {useEffect, useState} from 'react';
import * as css from './css/service';
import * as Api from 'api/api';

const Service = (props) => {
    const [app, setApp] = useState({});
    useEffect(() => {
        Api.app().then(data => {
            setApp(data.info);
        });
    })


    const {className} = props;

    return (
        <css.Service className={className}>
            <css.Title>欢迎来到 {app && app.websiteName}!</css.Title>
            <css.SubTitle>在这里可以享受到的服务</css.SubTitle>
            <css.ServiceContent>
                <css.ContentRow>
                    <css.ServiceItem>
                        <css.ItemImgWrapper>
                            <css.ServiceItemLineRight/>
                            <css.ItemImg src={require('./img/repair.png')}/>
                        </css.ItemImgWrapper>
                        <css.ItemText>
                            <css.ServiceItemLineRightDown/>
                            24小时快修服务
                        </css.ItemText>
                    </css.ServiceItem>
                    <css.ServiceItem>
                        <css.ItemImgWrapper>
                            <css.ServiceItemLineRight/>
                            <css.ItemImg src={require('./img/return-goods.png')}/>
                        </css.ItemImgWrapper>
                        <css.ItemText>
                            <css.ServiceItemLineRightDown/>
                            <css.ServiceItemLineLeftDown/>
                            7天无理由退货
                        </css.ItemText>
                    </css.ServiceItem>
                    <css.ServiceItem>
                        <css.ItemImgWrapper>
                            <css.ItemImg src={require('./img/exchange-goods.png')}/>
                        </css.ItemImgWrapper>
                        <css.ItemText>
                            <css.ServiceItemLineLeftDown/>
                            30天免费换货
                        </css.ItemText>
                    </css.ServiceItem>
                </css.ContentRow>
                <css.ContentRow>
                    <css.ServiceItem>
                        <css.ItemImgWrapper>
                            <css.ServiceItemLineRight right={-3}/>
                            <css.ItemImg src={require('./img/free-mail.png')}/>
                        </css.ItemImgWrapper>
                        <css.ItemText>满30包邮</css.ItemText>
                    </css.ServiceItem>
                    <css.ServiceItem>
                        <css.ItemImgWrapper>
                            <css.ItemImg src={require('./img/network-location.png')}/>
                        </css.ItemImgWrapper>
                        <css.ItemText>上千家余家售后网点</css.ItemText>
                    </css.ServiceItem>
                </css.ContentRow>
            </css.ServiceContent>
        </css.Service>
    );
}

export default Service;
